export default "__VITE_ASSET__BjN9_ctm__"